import { camelCase, isObject, snakeCase } from 'lodash';

import { isUpperCase } from 'core/utils';

export const objectKeysCamelToSnakeCase = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => objectKeysCamelToSnakeCase(item));
  }

  if (!isObject(data) || data instanceof File) {
    return data;
  }

  return Object.entries(data).reduce((obj, [key, value]) => {
    return {
      ...obj,
      [snakeCase(key)]: objectKeysCamelToSnakeCase(value),
    };
  }, {});
};

export const objectKeysSnakeCaseToCamelCase = (data) => {
  if (Array.isArray(data)) {
    return data.map((item) => objectKeysSnakeCaseToCamelCase(item));
  }

  if (!isObject(data)) {
    return data;
  }

  return Object.entries(data).reduce((obj, [key, value]) => {
    let newKey = key;

    if (!(key.startsWith('__') && key.endsWith('__')) && !isUpperCase(key)) {
      newKey = camelCase(key);
    }

    return {
      ...obj,
      [newKey]: objectKeysSnakeCaseToCamelCase(value),
    };
  }, {});
};

export const removeUnderscore = (string: string) => string?.replace(/_/g, ' ');
